import Component from './component'
import {connect} from 'react-redux'
import {atualizarStatusLote} from '../../../../actions/vendas'

const sTp = (state) => ({
    lotesInfos : state.database.vendas
})

const dTp = (dispatch) =>({
    mudarDisponibilidade : (e,d) => dispatch(atualizarStatusLote(e,d))
})

export default connect(sTp, dTp, null, { withRef: true })(Component)



// WEBPACK FOOTER //
// ./src/views/administrativo/vendas/controlbar/container.js